<template>
  <div class="donate-pre-form wwf-form dark row small-collapse medium-uncollapse">
    <div>
      <div v-if="this.productIds.length > 1" class="small-12 columns" style="text-align:right;">
        <div class="row small-collapse">
          <ul class="type-tab wwf-radio-bttns">
            <li v-for="productdetail in productidsdetail">
              <label class="wwf-controls radio" :for="'product-' +productdetail.productname">{{productdetail.productname}}
                <input type="radio" v-model="product" name="product" :value="productdetail" :id="'product-' +productdetail.productname" v-validate="'required'" />
                <div class="control__indicator"></div>
              </label>
            </li>
          </ul>
          <span class="alert-box" v-show="errors.has('product')">{{errors.first('product')}}</span>
        </div>
      </div>
      <div v-if="!emailprefill" class="small-12 medium-8 medium-centered columns">
        <input name="email" type="text" v-model="email" placeholder="Email">
      </div>
      <div class="small-12 columns dollar-handles">
        <div>
          <label v-for="(dollarhandle, index) in product.dollarhandles[product.donationtypes[0]]" class="wwf-controls radio" for="handle0">
            <span v-bind:class="{ selected: dollarhandle.amount ===  handle }" >${{(dollarhandle.amount.indexOf('.00') >= 0) ? dollarhandle.amount.slice(0,-3) : dollarhandle.amount}}</span>
            <input  v-if="!dollarhandleclick" type="radio" v-model="handle" :name="'handle'+index" :value="dollarhandle.amount" :id="'handle'+index" />
            <input v-if="dollarhandleclick" type="radio" v-model="handle" :name="'handle'+index" v-on:click="donateclick(dollarhandle.amount)" :value="dollarhandle.amount" :id="'handle'+index" />
            <div class="control__indicator"></div>
          </label>
          <label class="wwf-controls radio" for="handle4">
            <i v-bind:class="{ selected: handle === 'custom' }" class="fas fa-pencil-alt"></i>
            <input v-if="!dollarhandleclick" type="radio" v-model="handle" name="handle" value="custom" id="handle4" />
            <input v-if="dollarhandleclick" type="radio" v-model="handle" name="handle" v-on:click="donateclick('custom')" value="custom" id="handle4" />
            <div class="control__indicator"></div>
          </label>
        </div>
      </div>
      <div class="small-12 columns" v-if="!this.dollarhandleclick">
        <a href="#/" v-on:click="donate" class="bttn-lrg-arrw">Donate</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'donateRgForm',
      props: {
    productIds: {
      // Attribute for the productID
      type: Array,
      required: true
    },
    emailprefill: {
      // Attribute for the productID
      type: String,
      required: false,
      default: ''
    },
    currentpage:
    {
      // Attribute for the productID
      type: Boolean,
      required: false,
      default: false
    },
    dollarhandleclick:
    {
      // Attribute for the productID
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      email: '',
      handle: '',
      productidsdetail:null,
      product: null,
    }
  },
    created: function() {
    // Get product data (+ packages details)
    this.$store.dispatch("getProductByIds", this.productIds).then(
      response => {
        console.log("getProductByIds", response);
        this.productidsdetail = response;
        this.product = this.productidsdetail[0]
      },
      error => {
        console.error("getProductByIds error", error);
      }
    );
  },
  methods: {
    donateclick: function(dollar)
    {
      this.handle = dollar;
      this.donate();
    },
    donate: function () {
      this.$validator.validateAll().then(result => {

        if (result) {
          if (window.dataLayer != undefined) { window.dataLayer.push({ 'formName': 'donation', 'event': 'formSubmitSuccessEvent' }); }

          window.open(wwfconfigs.DONATEURL + this.product.urlPath + '?t='+this.product.appealcodesetting.appealid+'&f='+this.product.appealcodesetting.fundid+'&q='+window.btoa('email='+(this.emailprefill!='' ? this.emailprefill : this.email)+'&dollarhandle='+this.handle+'&amount='+(this.handle=='custom' ? '' : this.handle)),(this.currentpage ? "_self" : "_blank" ))

          return;
        }
        else {
          if (window.dataLayer != undefined) { window.dataLayer.push({ 'formName': 'donation', 'event': 'formSubmitEvent' }); }
        }
      });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// donateRgForm.vue?fc368540